import { useState } from "react";
import { Link } from "react-router-dom";
import { Printer } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { PageHeader, Th, Td, Empty, Tag, Segmented, DateRange, SectionTitle } from "@/components/common";
import PendingShipments from "@/components/PendingShipments";
import ShipmentCalendar from "@/components/ShipmentCalendar";
import { api, fmtDate, monthStart, todayStr, qty } from "@/lib/api";
import { useLoad, useQueryParam } from "@/lib/useLoad";

export default function Shipments() {
  const [kind, setKind] = useState("");
  useQueryParam("tur", setKind);
  const [start, setStart] = useState(monthStart());
  const [end, setEnd] = useState(todayStr());
  const [rows] = useLoad(() => api.get("/shipments", { params: { kind: kind || undefined, start, end } }).then((r) => r.data), [kind, start, end]);
  const list = rows || [];

  return (
    <div className="space-y-8">
      <PageHeader eyebrow="Sevk & Mal Kabul" title="Sevkiyatlar">
        <Button asChild variant="outline" className="rounded-[4px]" data-testid="shipments-report-button"><Link to="/raporlar?tip=shipments"><Printer /> Sevk Raporu</Link></Button>
      </PageHeader>
      <div>
        <SectionTitle sub="Sipariş teslim tarihleri ve yapılan sevkler">Sevk Takvimi</SectionTitle>
        <ShipmentCalendar />
      </div>
      <div>
        <SectionTitle sub="Açık siparişlerde kalan miktarlar">Sevk Bekleyenler</SectionTitle>
        <PendingShipments />
      </div>
      <div>
        <SectionTitle sub="Yapılan sevk ve mal kabuller">Sevk Geçmişi</SectionTitle>
        <div className="panel">
          <div className="flex flex-col gap-3 border-b border-border p-4 md:flex-row md:items-center md:justify-between">
            <Segmented value={kind} onChange={setKind} prefix="shipments-filter" options={[["", "Tümü"], ["sale", "Sevk"], ["purchase", "Mal Kabul"]]} />
            <DateRange start={start} end={end} onStart={setStart} onEnd={setEnd} prefix="shipments" />
          </div>
          <div className="overflow-x-auto">
            <table className="w-full" data-testid="shipments-table">
              <thead><tr><Th>No</Th><Th>Tarih</Th><Th>Tür</Th><Th>Sipariş</Th><Th>Cari</Th><Th>İrsaliye / Plaka</Th><Th right>Kalem</Th><Th right>Miktar</Th><Th>Fatura</Th><Th /></tr></thead>
              <tbody>
                {rows && list.length === 0 && <Empty cols={10} text="Bu aralıkta sevkiyat yok" />}
                {list.map((s) => (
                  <tr key={s.id} className="hover:bg-muted/40" data-testid={`shipment-row-${s.no}`}>
                    <Td className="font-num text-xs font-semibold">{s.no}</Td>
                    <Td className="font-num text-xs">{fmtDate(s.date)}</Td>
                    <Td><Tag tone={s.kind}>{s.kind === "sale" ? "Sevk" : "Mal Kabul"}</Tag></Td>
                    <Td><Link to={`/siparisler/${s.order_id}`} className="font-num text-xs text-primary hover:underline">{s.order_no}</Link></Td>
                    <Td><Link to={`/cariler/${s.account_id}`} className="font-medium hover:text-primary">{s.account_name}</Link></Td>
                    <Td className="text-muted-foreground">{[s.waybill_no, s.vehicle_plate].filter(Boolean).join(" · ") || "—"}</Td>
                    <Td right>{s.items.length}</Td>
                    <Td right>{qty(s.items.reduce((a, i) => a + i.qty, 0))}</Td>
                    <Td>{s.invoice_no ? <Link to={`/faturalar/${s.invoice_id}`} className="font-num text-xs text-primary hover:underline">{s.invoice_no}</Link> : <span className="text-xs text-muted-foreground">—</span>}</Td>
                    <Td className="text-right"><Button asChild size="sm" variant="ghost" data-testid={`shipment-print-${s.no}`}><Link to={`/irsaliye/${s.id}`} target="_blank"><Printer /> İrsaliye</Link></Button></Td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
